"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexSelectorComponent = void 0;
const lit_element_1 = require("lit-element");
require("@lion/button/define");
const style_1 = __importDefault(require("./style"));
let FlexSelectorComponent = class FlexSelectorComponent extends lit_element_1.LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.previousSelectedOption = 0;
        this.prefix = 'type';
        this.render = () => lit_element_1.html `${this.icon ? this.icon : null}
    ${this.options.length
            ? this.options.map((option, index) => lit_element_1.html ` <lion-button
                      class="${index === this.previousSelectedOption
                ? 'active'
                : ''}"
                      @click=${(e) => this.dispatchSelectedOption(e, option, index)}
                      position="${index}"
                      active="${index === this.previousSelectedOption}"
                      >${option}</lion-button
                  >`)
            : null}`;
        this.dispatchSelectedOption = (e, option, index) => {
            e.stopImmediatePropagation();
            if (this.previousSelectedOption !== index) {
                this.dispatchEvent(new CustomEvent('option-changed', {
                    detail: {
                        selector: this,
                        option,
                        prefix: this.prefix,
                    },
                }));
                this.previousSelectedOption = index;
            }
        };
    }
    static get styles() {
        return [style_1.default];
    }
};
__decorate([
    lit_element_1.property({ type: Array })
], FlexSelectorComponent.prototype, "options", void 0);
__decorate([
    lit_element_1.property({ type: Object })
], FlexSelectorComponent.prototype, "icon", void 0);
__decorate([
    lit_element_1.property({ type: Number })
], FlexSelectorComponent.prototype, "previousSelectedOption", void 0);
__decorate([
    lit_element_1.property({ type: String })
], FlexSelectorComponent.prototype, "prefix", void 0);
FlexSelectorComponent = __decorate([
    lit_element_1.customElement('flex-selector-component')
], FlexSelectorComponent);
exports.FlexSelectorComponent = FlexSelectorComponent;
